import { GatheringsPage } from './gatherings-page';

export const ServicesPage = () => <GatheringsPage kind="service" />;
